import React, {
  useState,
  useContext,
  useEffect,
  useRef,
  useCallback,
} from "react";
import "../../styles/pages/Banners/BannerManager.scss";
import "../../styles/components/kababMenu.scss";
import lockedOnCards from "../../images/TopRightCardIcons/lockedOnCards.svg";
import { ThreeDotMenu } from "./ThreeDotMenu.js";
import SaveRotate from "../../../src/images/save-rotate.svg";
import RefreshIcon from "../../images/refreshNew.svg";
import PreviewModal from "../Editor/Preview";
import EyeIcon from "../../images/EyeIcon.svg";
import Vector from "../../images/Vector.svg";

import { CircularProgress } from "@mui/material";
import {
  getSaveAssetsNodeApi,
  getSaveAssets,
  lockUnlockBanner,
  getbannerandTemplateDetails,
  getMLRstatus,
  getRSDAssetStatus,
  preview,
  validatePromomats,
  getDocIdfromveeva,
} from "../../services/apis";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import useVisible from "./useVisible";
import BasedOnModal from "./BasedOnModal.js";
import BannerDeleteModal from "./BannerDeleteModal.js";
import BannerLockUnlockModal from "./BannerLockUnlockModal.js";
import BannerAndTemplateDetailsModal from "./BannerAndTemplateDetailsModal";
import { withRouter } from "react-router-dom";
import ValueContext from "../../ContextAPi/appContext";
import ExportModal from "./ExportModal.js";
import ExportCenterContainer from "./ExportCenterContainer";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import CircleCheckedFilled from "@mui/icons-material/CheckCircle";
import CircleUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import time from "../../images/time.svg";
import RSDDialogueModal from "./RSDDialogueModal.js";
import { emitter, getStatusIcon } from "../../Uitls/Util.js";
import { createdDate } from "../../Uitls/EditorUtil.js";
import CopyModal from "./CopyBannerModal.js";
import config from "../../config/index";
import { fetchCustomFontsFromApi } from "../../services/customFontsApi.js";
import { isDisabled } from "../../Uitls/veeva.js";

function RecentlyViewedCard(props) {
  const appData = useContext(ValueContext);
  const {
    searchBanners,
    generateRVCV,
    setDisableProceedbut,
    selectMultipleBanner,
    setSelectMultipleBanner,
    indexResponseData,
    hide3dotIcon,
    lockUnlockBannerAtFE,
    fetchAllTemplates,
    setBannerDetails,
    bannerDetails,
    // docIdVeeva,
    getSearchedTemplates,
    isOneTime,
  } = props;

  const { t } = useTranslation();
  let url =
    "https://imc-preview.s3.ap-south-1.amazonaws.com/ContentStudio/Banners/dummy-post-horisontal.jpg";

  const { ref, visible, setVisible } = useVisible(false);
  const [showBasedOn, setShowBasedOn] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showLockModal, setShowLockModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [showExport, setExport] = useState(false);
  const [type, setType] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [exportDOMData, setExportDOMData] = useState({
    cards: "",
  });
  const [checkExportType, setCheckExportType] = React.useState({
    PDF: false,
    PNG: false,
    JPG: false,
    HTML: false,
    RVCVFILE: false,
  });
  const [htmlContent, setHtmlContent] = useState({
    html: null,
  });
  const [showPreview, setPreView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [previewURl, setpreviewURl] = useState({});
  const [rvcvTypes, setRvcvTypes] = React.useState({
    value2X: false,
    value3X: false,
  });
  const [latestMLRStatus, setLatestMLRStatus] = useState(null);
  const [docIdVeeva, setDocIdVeeva] = useState(null);
  const normalizeDocId = useCallback((docId) => {
    if (docId === null || docId === undefined) return "";
    const normalized = String(docId).trim().toUpperCase();
    return normalized && normalized !== "-" ? normalized : "";
  }, []);
  const isSameDocId = useCallback(
    (a, b) => {
      const normalizedA = normalizeDocId(a);
      const normalizedB = normalizeDocId(b);
      return !!normalizedA && !!normalizedB && normalizedA === normalizedB;
    },
    [normalizeDocId],
  );

  const [articleUpdating, setArticleUpdating] = useState(false);
  const [showRSDProgress, setshowRSDProgress] = useState(false);
  const [isDetailsLoading, setIsDetailsLoading] = useState(false);
  const [showDetailsLoader, setShowDetailsLoader] = useState(false);
  const detailsLoaderDelayRef = useRef(null);
  const detailsLoaderHideRef = useRef(null);
  const detailsLoaderShownAtRef = useRef(0);

  const DETAILS_LOADER_DELAY_MS = 180;
  const DETAILS_LOADER_MIN_VISIBLE_MS = 240;
  // const [isOnetimeAsset, setIsonetimeAsset] = useState(false);
  const bannerExpiryStatus =
    latestMLRStatus || props?.recentlyViewedData?.mlrStatus || "Not Submitted";
  const clearDetailsLoaderTimers = () => {
    if (detailsLoaderDelayRef.current) {
      clearTimeout(detailsLoaderDelayRef.current);
      detailsLoaderDelayRef.current = null;
    }
    if (detailsLoaderHideRef.current) {
      clearTimeout(detailsLoaderHideRef.current);
      detailsLoaderHideRef.current = null;
    }
  };
  const startDetailsLoader = () => {
    setIsDetailsLoading(true);
    clearDetailsLoaderTimers();
    detailsLoaderShownAtRef.current = 0;
    detailsLoaderDelayRef.current = setTimeout(() => {
      detailsLoaderShownAtRef.current = Date.now();
      setShowDetailsLoader(true);
      detailsLoaderDelayRef.current = null;
    }, DETAILS_LOADER_DELAY_MS);
  };
  const stopDetailsLoader = () => {
    setIsDetailsLoading(false);
    if (detailsLoaderDelayRef.current) {
      clearTimeout(detailsLoaderDelayRef.current);
      detailsLoaderDelayRef.current = null;
    }

    if (!detailsLoaderShownAtRef.current) {
      setShowDetailsLoader(false);
      return;
    }

    const elapsed = Date.now() - detailsLoaderShownAtRef.current;
    const remaining = Math.max(0, DETAILS_LOADER_MIN_VISIBLE_MS - elapsed);
    detailsLoaderHideRef.current = setTimeout(() => {
      detailsLoaderShownAtRef.current = 0;
      setShowDetailsLoader(false);
      detailsLoaderHideRef.current = null;
    }, remaining);
  };
  const getPrefilledBannerDetails = () => {
    const recentData = props?.recentlyViewedData || {};
    const hasCardSize = recentData?.width && recentData?.height;
    const normalizedPrefillAssetName = (() => {
      const rawName = recentData?.assetName;
      if (!rawName) return "-";
      const cleanedName = String(rawName)
        .trim()
        .replace(/_(\d+)\s*[xX×]\s*(\d+)$/i, "");
      return cleanedName || "-";
    })();
    return {
      oneTimeAsset: Boolean(isOneTime),
      veevaDocNumber: recentData?.damDocNumber || "-",
      assetName: normalizedPrefillAssetName,
      isAnimated: Boolean(recentData?.isAnimated),
      sizes: hasCardSize ? [`${recentData.width}x${recentData.height}`] : [],
      brandName: recentData?.brandName || "-",
      marketName: recentData?.marketName || "-",
      reviewStatus: latestMLRStatus || recentData?.mlrStatus || "Not Submitted",
    };
  };
  const checkMultipleBanner = (event, id) => {
    let maxCheckboxSelection = [...selectMultipleBanner];
    let checkboxSelection = maxCheckboxSelection.filter(
      (element) => element.toggleRVCV === true,
    );

    if (checkboxSelection?.length >= 5 && event.target.checked) {
      return toast.error(
        <div className="notificationText">
          {t("Selection of more than 5 banners is not allowed")}
        </div>,
      );
    }
    const updatedCheckedState = selectMultipleBanner.map((item, index) => {
      return item.id === id ? { ...item, toggleRVCV: !item.toggleRVCV } : item;
    });
    setSelectMultipleBanner(updatedCheckedState);
  };
  useEffect(() => {
    const handleMLRStatusUpdate = (data) => {
      const cardDocNumbers = [
        props?.recentlyViewedData?.damDocNumber,
        props?.recentlyViewedData?.veevaDocNumber,
        props?.recentlyViewedData?.documentNumber,
      ];
      const eventDocNumbers = [
        data?.damDocNumber,
        data?.documentNumber,
        data?.veevaDocNumber,
        data?.elementName,
      ];
      const cardIds = [
        props?.recentlyViewedData?.id,
        props?.recentlyViewedData?.damDocId,
        props?.recentlyViewedData?.documentId,
      ]
        .map((value) => normalizeDocId(value))
        .filter(Boolean);
      const eventIds = [data?.damDocId, data?.documentId, data?.id]
        .map((value) => normalizeDocId(value))
        .filter(Boolean);

      const isCurrentCardEvent = cardDocNumbers.some((cardDocId) =>
        eventDocNumbers.some((eventDocId) =>
          isSameDocId(eventDocId, cardDocId),
        ),
      );
      const isCurrentCardIdEvent = cardIds.some((cardId) =>
        eventIds.some((eventId) => eventId === cardId),
      );

      if (isCurrentCardEvent || isCurrentCardIdEvent) {
        setLatestMLRStatus(
          data?.mlrStatus ||
            data?.reviewStatus ||
            data?.status ||
            "Not Submitted",
        );
      }
    };

    emitter.on("autoSync", handleMLRStatusUpdate);

    return () => {
      emitter.off("autoSync", handleMLRStatusUpdate);
    };
  }, [
    props?.recentlyViewedData?.damDocNumber,
    props?.recentlyViewedData?.veevaDocNumber,
    props?.recentlyViewedData?.documentNumber,
    props?.recentlyViewedData?.id,
    props?.recentlyViewedData?.damDocId,
    props?.recentlyViewedData?.documentId,
    normalizeDocId,
    isSameDocId,
  ]);

  useEffect(() => {
    let newArrayList = props.responseData.map((recentlyViewData) => ({
      id: recentlyViewData.id,
      data: recentlyViewData,
      toggleRVCV: false,
    }));
    setSelectMultipleBanner(newArrayList);
  }, [props.responseData]);

  useEffect(() => {
    let obj = selectMultipleBanner.find((o) => o.toggleRVCV === true) || [];
    if (obj.toggleRVCV) {
      setDisableProceedbut(true);
    } else {
      setDisableProceedbut(false);
    }
  }, [selectMultipleBanner]);
  useEffect(() => {
    return () => {
      if (detailsLoaderDelayRef.current) {
        clearTimeout(detailsLoaderDelayRef.current);
      }
      if (detailsLoaderHideRef.current) {
        clearTimeout(detailsLoaderHideRef.current);
      }
    };
  }, []);

  const getLatestMLRStatus = (id) => {
    setArticleUpdating(true);
    getMLRstatus(id, async (response, err) => {
      if (err) {
        setArticleUpdating(false);
      } else {
        const data = await response.data;
        setLatestMLRStatus(data?.mlrStatus || "Not Submitted");
        setArticleUpdating(false);
      }
    });
  };
  const getDocIdveeva = (id) => {
    getDocIdfromveeva(id, async (response, err) => {
      if (err) {
        toast.error(
          <div className="notificationText">
            {t("Failed to get the Doc Id")}
          </div>,
        );
      } else {
        const data = await response.data;
        const docId = data?.data;
        setDocIdVeeva(docId);
        window.open(`${config.globalPromomatsUrl}#doc_info/${docId}`);
      }
    });
  };

  const exportType = (type) => {
    getSaveAssetsNodeApi(props.recentlyViewedData.id, async (response, err) => {
      const data = await response.data;

      if (err) {
        props.setLoading(false);
      } else {
        const assetInfo = {
          assetId: data.id,
          assetName: data.assetName,
        }
        appData.setAssetInfo(assetInfo);

        const customFonts = await fetchCustomFontsFromApi({ assetInfo })
        appData.setSavedCustomFontList(customFonts)

        setExportDOMData({
          cards: response.data,
        });
        setType(type);
      }
    });
  };
  const handlePreview = async () => {
    setCheckExportType({
      ...checkExportType,
      PDF: false,
      HTML: false,
      PNG: false,
      JPG: false,
      RVCVFILE: false,
      SampleBanner: false,
      Preview: true,
    });
    exportType("Preview");
    if (htmlContent.html) {
      generatePreview();
    }
  };
  const generatePreview = async () => {
    let DOMObjHtml = await JSON.parse(htmlContent.html);
    let PreviewDOM = {
      html: DOMObjHtml,
      fileName: props.recentlyViewedData.assetName,
    };
    preview(PreviewDOM, (response, err, errorCode) => {
      setLoading(true);
      if (err) {
        const errComponent = ErrComponentToRender(errorCode);
      } else {
        if (response.data) {
          setpreviewURl(response.data);
          setPreView(true);
          /**
           * Setting the checkExportType Preview to false to prevent the export type from being set to Preview line 393-402
           */
          setCheckExportType({
            ...checkExportType,
            PDF: false,
            HTML: false,
            PNG: false,
            JPG: false,
            RVCVFILE: false,
            SampleBanner: false,
            Preview: false,
          });
        }
      }
      setLoading(false);
    });
  };
  useEffect(() => {
    if (htmlContent.html) {
      generatePreview();
    }
  }, [htmlContent.html]);

  const handleDeleteBanner = () => {
    setShowDelete(true);
    setVisible(!visible);
  };
  const handleLockBannerModal = (type) => {
    setShowLockModal(true);
    setVisible(!visible);
    if (type === "Lock") {
      setIsLocked(true);
    } else {
      setIsLocked(false);
    }
  };

  const handleOpenDetailsModal = () => {
    const id = props.recentlyViewedData?.id;
    if (!id || isDetailsLoading) return;
    setVisible(false);
    startDetailsLoader();
    getDetails();
  };
  const mapApiToBannerDetails = (api) => {
    if (!api || typeof api !== "object") return {};
    const asset = api.assetDetails || {};
    const source = api.sourceAssetDetails || {};
    const rsd = api.rsdDetails || {};
    const normalizeSizes = (arr) =>
      Array.isArray(arr) && arr.length
        ? arr.map((s) => String(s).replace(/\s*x\s*/i, "×"))
        : [];

    return {
      veevaDocNumber: asset.veevaDocNumber || "-",
      reviewStatus: asset.reviewStatus || asset.mlrStatus || "",
      assetName: asset.assetName || "-",
      isAnimated: !!asset.isAnimated,
      sizes: normalizeSizes(asset.size),
      brandName: asset.brandName || "-",
      marketName: asset.marketName || "-",
      rsdDocNumber: rsd.rsdDocNumber || "-",
      rsdReviewStatus:
        rsd.rsdReviewStatus || rsd.reviewStatus || rsd.mlrStatus || "",
      rsdPublishedOn: rsd.publishedOn || null,
      rsdApprovedOn: rsd.approvedOn || null,
      isCopied: !!api.sourceAssetDetails,
      sourceVeevaDocNumber: source.veevaDocNumber || "-",
      sourceReviewStatus:
        source.sourceReviewStatus ||
        source.reviewStatus ||
        source.mlrStatus ||
        "",
      sourceAssetName: source.assetName || "-",
      sourceIsAnimated: !!source.isAnimated,
      sourceSizes: normalizeSizes(source.size),
      sourceBrandName: source.brandName || "-",
      sourceMarketName: source.marketName || "-",
      createdByName: asset.createdByName || "-",
      createdDateTime: asset.createdDateTime || null,
      updatedByName: asset.updatedByName || "-",
      updatedDateTime: asset.updatedDateTime || null,
      publishedByName: rsd.publishedByName || "",
      publishedOn: rsd.publishedOn || null,
      publishedBy: rsd.publishedBy || "",
      veevaDocUrl: asset.veevaDocUrl || "",
      rsdDocUrl: rsd.rsdDocUrl || "",
      createdByEmail: asset.createdByEmail || "",
      updatedByEmail: asset.updatedByEmail || "",
      sourceAssetId: source.id || "",
      oneTimeAsset: Boolean(asset?.oneTimeAsset) || Boolean(isOneTime),
    };
  };
  const handleOpenCopyModal = () => {
    setShowCopyModal(true);
  };

  const getDetails = () => {
    const id = props.recentlyViewedData?.id;
    if (!id) {
      setBannerDetails(getPrefilledBannerDetails());
      setShowDetails(true);
      stopDetailsLoader();
      return;
    }

    getbannerandTemplateDetails(id, async (response, err) => {
      if (err) {
        setBannerDetails(getPrefilledBannerDetails());
        setShowDetails(true);
        stopDetailsLoader();
        return;
      }
      const api = await response?.data;
      const mapped = mapApiToBannerDetails(api);
      setBannerDetails((prev) => ({
        ...mapped,
        reviewStatus:
          prev?.reviewStatus ||
          mapped?.reviewStatus ||
          latestMLRStatus ||
          props?.recentlyViewedData?.mlrStatus ||
          "Not Submitted",
        sourceReviewStatus:
          prev?.sourceReviewStatus ||
          mapped?.sourceReviewStatus ||
          "Not Submitted",
        rsdReviewStatus:
          prev?.rsdReviewStatus || mapped?.rsdReviewStatus || "Not Submitted",
      }));
      setShowDetails(true);
      stopDetailsLoader();
    });
  };

  const assetLockUnlock = (id, lockStatus, assetType) => {
    props.setLoading(true);
    lockUnlockBanner(id, lockStatus, assetType, (err) => {
      if (err && err.status !== 200) {
        if (lockStatus === "Locked") {
          toast.error(
            <div className="notificationText">
              {t("Failed to lock the banner")}
            </div>,
          );
        } else {
          toast.error(
            <div className="notificationText">
              {t("Failed to send the unlock request")}
            </div>,
          );
        }

        props.setLoading(false);
      } else {
        setVisible(false);
        setShowLockModal(false);
        props.setLoading(false);
        lockUnlockBannerAtFE(id, lockStatus);
        if (lockStatus === "Locked") {
          toast.success(
            <div className="notificationText">
              {t("Banner has been successfully locked")}
            </div>,
          );
        } else {
          toast.success(
            <div className="notificationText">
              {t("Banner has been successfully unlocked")}
            </div>,
          );
        }
      }
    });
  };

  const fileValidation = () => {
    getSaveAssets(
      props.recentlyViewedData.id,
      async (response, err, errorCode) => {
        const data = await response.data;

        if (err) {
          props.setLoading(false);
        } else {
          if (data?.attributes?.bannerSize === 200) {
            toast.error(
              <div className="notificationText">
                {t("Warning - Banner size exceeds 200 KB!")}
              </div>,
            );
          }
        }
      },
    );
  };

  const isEditable = isDisabled({bannerExpiryStatus, 
    marketName : props?.recentlyViewedData?.marketName,
    latestMLRStatus,
    mlrStatus : props?.recentlyViewedData?.mlrStatus});

  const isModuleBasedBanner = Boolean(
    props?.recentlyViewedData?.modules?.length > 0,
  );
  const isOneTimeBanner =
    Boolean(isOneTime) || Boolean(props?.recentlyViewedData?.oneTimeAsset);
  const isOneTimeBannerForCopy = !isModuleBasedBanner && isOneTimeBanner;

  const getBannerMetaForEdit = () => {
    const localModules = props?.recentlyViewedData?.modules;
    if (Array.isArray(localModules)) {
      return Promise.resolve({
        hasModules: localModules.length > 0,
        oneTimeAsset: isOneTimeBanner,
      });
    }

    return new Promise((resolve) => {
      getSaveAssets(props?.recentlyViewedData?.id, async (response, err) => {
        if (err) {
          resolve({
            hasModules: true,
            oneTimeAsset: isOneTimeBanner,
          });
          return;
        }
        const data = await response?.data;
        resolve({
          hasModules: Array.isArray(data?.modules) && data.modules.length > 0,
          oneTimeAsset: Boolean(data?.oneTimeAsset) || isOneTimeBanner,
        });
      });
    });
  };

  const handleEditClick = async () => {
    let response = await getRSDAssetStatus(
      props?.recentlyViewedData?.damDocNumber || "",
    );
    if (response?.data === "INPROGRESS") {
      setshowRSDProgress(true);
      return;
    }

    const { hasModules, oneTimeAsset } = await getBannerMetaForEdit();

    appData.setFlagEditFlow(true);
    window.localStorage.setItem("oneTimeAsset", JSON.stringify(oneTimeAsset));
    props.history.push({
      pathname: `/banner-editor/${props.recentlyViewedData.id}`,
      state: {
        editClicked: true,
        newBanner: !oneTimeAsset && !hasModules,
        onetimeBanner: oneTimeAsset,
        prefillBannerName: props?.recentlyViewedData?.assetName || "",
        prefillIsAnimated: Boolean(props?.recentlyViewedData?.isAnimated),
        prefillBannerType: props?.recentlyViewedData?.isAnimated
          ? "Animated"
          : "Static",
        prefillAssetType: props?.recentlyViewedData?.assetType || "Banner",
      },
    });
  };

  const moduleCardMenuOptions = [
    (props.recentlyViewedData.lockStatus !== "Locked" ||
      props.recentlyViewedData.madeBy === "me") && (
      <li className="pl-0 pr-0">
        <button
          disabled={isEditable}
          className={
            isEditable
              ? "btn p-0 m-0 w-100 text-left pr12 pl12 lh32 btnDisabled"
              : "btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
          }
          onClick={handleEditClick}
        >
          {"Edit"}
        </button>
      </li>
    ),
    <li className="pl-0 pr-0">
      <button
        className="btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          setExport(true);
          setCheckExportType({
            ...checkExportType,
            PDF: false,
            HTML: false,
            PNG: false,
            JPG: false,
            RVCVFILE: false,
          });
          setRvcvTypes({
            ...rvcvTypes,
            value2X: false,
            value3X: false,
          });
          setVisible(!visible);
          props.setLoading(true);
          fileValidation();
        }}
      >
        {t("bannerManager.kababMenu.export")}
      </button>
    </li>,
    <li className="pl-0 pr-0">
      <button
        className="btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          handleOpenDetailsModal();
        }}
      >
        {t("Details")}
      </button>
    </li>,
    props?.recentlyViewedData?.madeBy === "me" &&
      (props?.recentlyViewedData?.lockStatus === "Locked" ? (
        <li className="pl-0 pr-0">
          <button
            className="btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
            onClick={() => {
              handleLockBannerModal("Unock");
            }}
          >
            {t("bannerManager.kababMenu.unlock")}
          </button>
        </li>
      ) : (
        <li className="pl-0 pr-0">
          <button
            className="btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
            onClick={() => {
              handleLockBannerModal("Lock");
            }}
          >
            {t("bannerManager.kababMenu.lock")}
          </button>
        </li>
      )),

    <li className="pl-0 pr-0">
      <button
        className="btn p-0 m-0 w-100 text-left pr12 pl12 lh32"
        onClick={() => {
          handleOpenCopyModal();
        }}
      >
        {t("Make a Copy")}
      </button>
    </li>,
  ];

  const currentSize =
    props?.recentlyViewedData?.width && props?.recentlyViewedData?.height
      ? `${props.recentlyViewedData.width}x${props.recentlyViewedData.height}`
      : null;

  const pages = props?.recentlyViewedData?.assetpages ?? [];
  const hasComponents = pages.some(
    (p) => (p?.assetpagecomponent?.length ?? 0) > 0,
  );

  const rawThumb = props?.recentlyViewedData?.thumbNail;
  const thumb = (rawThumb ?? "").trim();

  const bgImage = !hasComponents
    ? "none"
    : thumb
      ? `url(${thumb})`
      : `url(${url})`;
  const getStatusClass = (status) => {
    if (!status) return "";

    const s = status.toLowerCase();
    if (s === "approved for use") {
      return "status-approved";
    }

    if (s === "draft" || s === "not submitted") {
      return "status-draft";
    }

    if (s === "expired") {
      return "status-expired";
    }

    return "status-other";
  };
  const handleViewRsdDocinveeva = () => {
    // window.open(
    //   `https://sb-gilead-poc-global-promomats.veevavault.com/ui/#doc_info/${docIdVeeva}`,
    // );
    getDocIdveeva(props?.recentlyViewedData?.damDocNumber);
  };
  return (
    <>
      <div className="recentlyViewCard">
        {/* {isOneTimeBanner && (
          <div className="otcContentTag">One-time content</div>
        )} */}
        <div className="rvcvfileSelction">
          {generateRVCV && (
            <FormControl component="fieldset">
              <FormGroup
                aria-label="format"
                name="format"
                className="selectMultiplecheckbox"
              >
                <FormControlLabel
                  value="selectRVCV"
                  id="checkForRvcv"
                  control={
                    <Checkbox
                      id={`custom-checkbox-${indexResponseData}`}
                      icon={<CircleUnchecked />}
                      checkedIcon={<CircleCheckedFilled />}
                      checked={
                        selectMultipleBanner[indexResponseData]?.toggleRVCV
                      }
                      onChange={(e) =>
                        checkMultipleBanner(e, props.recentlyViewedData.id)
                      }
                      name="selectRVCV"
                    />
                  }
                />
              </FormGroup>
            </FormControl>
          )}
        </div>

        {(loading || showDetailsLoader) && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress size="30px" className="customLoader" />{" "}
          </>
        )}
        <div className="bannerImagesDiv ">
          <div
            style={{
              height: "148px",
              backgroundImage: bgImage,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
            alt="Banner"
            className="bannerImages img-fluid"
          />
          <div className="middle">
            <div
              className="overlaytext overlaytextTemp"
              onClick={() => {
                handlePreview();
              }}
            >
              <img src={EyeIcon} alt="arrow" className="arrowwithcircle" />

              {t("Preview")}
            </div>
          </div>
          <div className="export-container" style={{ display: "none" }}>
            {type && (
              <ExportCenterContainer
                exportDOMData={exportDOMData}
                setType={setType}
                type={type}
                setLoading={props.setLoading}
                checkExportType={checkExportType}
                setHtmlContent={setHtmlContent}
                htmlContent={htmlContent}
                rvcvTypes={rvcvTypes}
                setRvcvTypes={setRvcvTypes}
                setCheckExportType={setCheckExportType}
                backupFallback={props?.recentlyViewedData?.backupImages}
              ></ExportCenterContainer>
            )}
          </div>
        </div>
        <div
          style={{
            height: "111px",
            borderBottomLeftRadius: "6px",
            borderBottomRightRadius: "6px",
          }}
          // className={`${
          //   bannerExpiryStatus === "Expired" ? "bannerCardExpired" : ""
          // }`}
        >
          <div className="bannerRow" style={{ paddingTop: "12px" }}>
            <div className="bannerTopRight"></div>
          </div>
          <div className="content-block1">
            <div
              className=" cursor-default flex items-center justify-left space-x-2"
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
              }}
            >
              <div
                //className="showStatusesbg d-flex"
                className={`showStatusesbg d-flex ${getStatusClass(
                  latestMLRStatus || props?.recentlyViewedData?.mlrStatus,
                )}`}
                onClick={() =>
                  handleViewRsdDocinveeva(
                    props?.recentlyViewedData?.damDocNumber,
                  )
                }
              >
                {
                  <Tooltip
                    title={
                      latestMLRStatus ||
                      props?.recentlyViewedData?.mlrStatus ||
                      "Not Submitted"
                    }
                  >
                    <img
                      src={getStatusIcon(
                        latestMLRStatus ||
                          props?.recentlyViewedData?.mlrStatus ||
                          "Not submitted",
                      )}
                      alt="Status Icon"
                      width={12}
                      height={12}
                      style={{ marginTop: "2px" }}
                    />
                  </Tooltip>
                }
                <div
                  style={{
                    marginLeft: "5px",
                    fontWeight: "600",
                    fontSize: "12px",
                  }}
                >
                  {props?.recentlyViewedData?.damDocNumber ?? "-"}
                </div>

                {bannerExpiryStatus === "Expired" && (
                  <Tooltip
                    title={"Banner is expired can't be used for Editing"}
                  >
                    <div className="expiredBanner">Expired</div>
                  </Tooltip>
                )}
                <img
                  src={Vector}
                  alt="veeva redirection"
                  width={12}
                  height={12}
                  style={{
                    marginTop: "3px",
                    marginLeft: "6px",
                    cursor: "pointer",
                  }}
                />
              </div>
              {!props?.recentlyViewedData?.damDocNumber ? (
                ""
              ) : articleUpdating ? (
                <img
                  src={SaveRotate}
                  alt="Saving icon"
                  className="saveRotateCard"
                  style={{
                    cursor: "pointer",
                    marginLeft: "5px",
                    height: "12px",
                    width: "9.93px",
                    position: "relative",
                    top: "-2px",
                  }}
                />
              ) : (
                <img
                  src={RefreshIcon}
                  alt="Refresh Icon"
                  onClick={() =>
                    getLatestMLRStatus(props?.recentlyViewedData?.damDocNumber)
                  }
                  style={{
                    cursor: "pointer",
                    marginLeft: "5px",
                    position: "relative",
                    top: "-2px",
                  }}
                />
              )}
              {/* {bannerExpiryStatus === "Expired" && (
                <Tooltip title={"Banner is expired can't be used for Editing"}>
                  <div className="expiredBanner">Expired</div>
                </Tooltip>
              )} */}
            </div>
            <div className="d-flex">
              <p
                className="basic-info"
                style={{ marginBottom: "6px", width: "50%" }}
              >
                <span className="nameHeading">Product:</span>{" "}
                <strong className="truncate">
                  {props.recentlyViewedData.brandName}
                </strong>
              </p>
              <p className="basic-info" style={{ marginBottom: "6px" }}>
                <span className="nameHeading">Country:</span>{" "}
                <strong className="truncate">
                  {props.recentlyViewedData.marketName}
                </strong>
              </p>
            </div>
            <p className="basic-info" style={{ marginBottom: "6px" }}>
              <span className="nameHeading">Name:</span>{" "}
              <Tooltip title={props.recentlyViewedData.assetName}>
                <strong className="truncate2">
                  {props.recentlyViewedData.assetName}
                </strong>
              </Tooltip>
            </p>
          </div>
          <div className="edit-popup-2">
            <div className="time">
              <img className="timeIcon" src={time}></img>
              {createdDate(props?.recentlyViewedData?.createdDateTime)}
            </div>

            <div className="lock-threedot">
              <div className="locked">
                {" "}
                {props.recentlyViewedData.lockStatus === "Locked" ? (
                  <img
                    src={lockedOnCards}
                    alt="lockbanner"
                    className="img-fluid"
                  />
                ) : (
                  ""
                )}
              </div>
              {hide3dotIcon ? (
                <div className="kababIcon">
                  <>
                    <div>
                      <ThreeDotMenu menuOptions={moduleCardMenuOptions} />
                    </div>
                  </>

                  {false ? (
                    <div className="kababMenu" ref={ref}>
                      {(props.recentlyViewedData.lockStatus !== "Locked" ||
                        props.recentlyViewedData.madeBy === "me") && (
                        <>
                          <div
                            className={`kababMenu--option`}
                            onClick={async () => {
                              appData.setFlagEditFlow(true);
                              props.history.push({
                                pathname: `/banner-editor/${props.recentlyViewedData.id}`,
                                state: { editClicked: true },
                              });
                            }}
                          >
                            {t("bannerManager.kababMenu.edit")}
                          </div>
                        </>
                      )}
                      <div
                        className="kababMenu--option"
                        onClick={() => {
                          setExport(true)
                          setCheckExportType({
                            ...checkExportType,
                            PDF: false,
                            HTML: false,
                            PNG: false,
                            JPG: false,
                            RVCVFILE: false,
                          });
                          setRvcvTypes({
                            ...rvcvTypes,
                            value2X: false,
                            value3X: false,
                          });
                          setVisible(!visible);
                          props.setLoading(true);
                          fileValidation();
                        }}
                      >
                        {t("bannerManager.kababMenu.export")}
                      </div>

                      {props.recentlyViewedData.madeBy === "me" && (
                        <>
                          <div
                            className="kababMenu--option"
                            onClick={() => handleDeleteBanner()}
                          >
                            {t("bannerManager.kababMenu.delete")}
                          </div>
                        </>
                      )}

                      {props?.recentlyViewedData?.madeBy === "me" ? (
                        props?.recentlyViewedData?.lockStatus === "Locked" ? (
                          <div
                            className="kababMenu--option"
                            onClick={() => handleLockBannerModal("Unlock")}
                          >
                            {t("bannerManager.kababMenu.unlock")}
                          </div>
                        ) : (
                          <>
                            {
                              <div
                                className="kababMenu--option"
                                onClick={() => handleLockBannerModal("Lock")}
                              >
                                {t("bannerManager.kababMenu.lock")}
                              </div>
                            }
                          </>
                        )
                      ) : (
                        ""
                      )}

                      <>
                        <div
                          className="kababMenu--option"
                          onClick={() => {
                            handleOpenDetailsModal();
                          }}
                        >
                          {t("Details")}
                        </div>
                      </>
                    </div>
                  ) : null}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="text-center">
          {showBasedOn && (
            <BasedOnModal
              showBasedOn={showBasedOn}
              recentlyViewedData={props.recentlyViewedData}
              setShowBasedOn={setShowBasedOn}
            />
          )}
          {showExport && (
            <ExportModal
              showBasedOn={showExport}
              setExport={setExport}
              setLoading={props.setLoading}
              exportType={exportType}
              checkExportType={checkExportType}
              setCheckExportType={setCheckExportType}
              rvcvTypes={rvcvTypes}
              setRvcvTypes={setRvcvTypes}
              genericInfo={props.genericInfo}
              setGenericInfo={props.setGenericInfo}
              toggleAnimatedBanner={props.recentlyViewedData.isAnimated}
            />
          )}
          {showDelete && (
            <BannerDeleteModal
              showDelete={showDelete}
              setShowDelete={setShowDelete}
              searchType={props.search}
              recentlyViewedData={props.recentlyViewedData}
              getRecentlyViewedBanner={props.getRecentlyViewedBanner}
              removeSearchresultCard={props.removeSearchresultCard}
            />
          )}
          {showDetails && (
            <div className="details-mod">
              <BannerAndTemplateDetailsModal
                setLoading={props.setLoading}
                showDetails={showDetails}
                setShowDetails={setShowDetails}
                loading={props.loading}
                lockStatus={props.recentlyViewedData.lockStatus}
                historyprops={props.history}
                bannerDetails={bannerDetails}
                setBannerDetails={setBannerDetails}
                recentlyViewedData={props?.recentlyViewedData}
                currentSize={currentSize}
              />
            </div>
          )}
          {showCopyModal && (
            <CopyModal
              open={showCopyModal}
              validatePromomats={validatePromomats}
              onClose={() => setShowCopyModal(false)}
              onCreate={(results) => {
                setShowCopyModal(false);
                if (
                  props.search === "search" &&
                  typeof getSearchedTemplates === "function"
                ) {
                  getSearchedTemplates(1);
                } else {
                  fetchAllTemplates("copy");
                }
              }}
              parentDamDocNumber={props?.recentlyViewedData?.damDocNumber}
              assetType={props?.recentlyViewedData?.assetType}
              brandId={props?.recentlyViewedData?.brandId}
              brandName={props?.recentlyViewedData?.brandName}
              marketCode={props?.recentlyViewedData?.marketCode}
              marketName={props?.recentlyViewedData?.marketName}
              isAnimated={props?.recentlyViewedData?.isAnimated}
              isOneTimeContent={
                Boolean(props?.recentlyViewedData?.oneTimeAsset) ||
                Boolean(isOneTime)
              }
              isOneTimeBanner={isOneTimeBannerForCopy}
              parentAssetName={props?.recentlyViewedData?.assetName}
            />
          )}
          {showLockModal && (
            <BannerLockUnlockModal
              fetchAllTemplates={fetchAllTemplates}
              setShowLockModal={setShowLockModal}
              showLockModal={showLockModal}
              handleLockBannerModal={handleLockBannerModal}
              assetLockUnlock={assetLockUnlock}
              recentlyViewedData={props.recentlyViewedData}
              isLocked={isLocked}
              loading={props.loading}
              searchBanners={searchBanners}
            />
          )}
          {showRSDProgress && (
            <RSDDialogueModal
              setshowRSDProgress={setshowRSDProgress}
              showRSDProgress={showRSDProgress}
            />
          )}
          {showPreview && (
            <PreviewModal
              assetId={props?.recentlyViewedData?.id}
              previewURl={previewURl}
              previewAssetData={exportDOMData?.cards}
              setPreview={setPreView}
              showPreview={showPreview}
              setLoading={setLoading}
              showBackupImageTab
            />
          )}
        </div>
      </div>
    </>
  );
}

export default withRouter(RecentlyViewedCard);
